import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { SetupLearner } from "../../redux/actions/AuthAction";
import { useSnackbar } from "react-simple-snackbar";


const InfoForm = ({ userData, setProfile, userToken }) => {

  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();

  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [profession, setProfession] = useState("");
  const [level, setLevel] = useState("");
  const [emailOrPhonenumber, setEmailOrPhonenumber] = useState("");
  const [referal, setReferal] = useState("");
  const [loder, setLoder] = useState(false);

  var user = userData ? userData : JSON.parse(localStorage.getItem("DATA"));

  const [errormsg, setErrormsg] = useState("");
  console.log(user)

  const setupLearner = (e) => {
    e.preventDefault();
    setLoder(true);
    const details = {
      // learner: user._id,
      name: name,
      email: JSON.parse(localStorage.getItem("USER")).isGoogleLogedin ? user.email: email,
      phoneNumber: JSON.parse(localStorage.getItem("USER")).phoneNumber ? user.phoneNumber: number,
      city: city,
      // profession: profession,
      // currentLevel: level,
      // emailOrPhonenumber: emailOrPhonenumber,
      // referal: referal ? referal : "1",
    };

    const token = userToken ? userToken : user.token;
    const data = {
      details,
      token,
    };

    Object.assign(user, details);

    const onSuccess = (message, statusCode) => {
      setLoder(false);
      openSnackbar(message);
      localStorage.setItem("USER", JSON.stringify(user));
      window.location.reload();
    };

    const onError = (message) => {
      console.log(message);
      // openSnackbar(message);
      // setErrormsg(message);
      setLoder(false)
    };

    dispatch(SetupLearner(details, onSuccess, onError));
  };

  return (
    <form onSubmit={(e) => setupLearner(e)}>
      <div className="modal-body">
        <div class="form-group mt-3">
          <label className="d-flex">
            <h1
              style={{
                fontSize: "32px",
                fontWeight: "bolder",
                lineHeight: "20px",
              }}
            >
              Hello
            </h1>{" "}
            <span
              className="pl-2"
              style={{
                color: "#4DC591",
                fontWeight: "600",
                fontSize: "18px",
                lineHeight: "18px",
              }}
            >
              {/* {user ? user.phoneNumber ? user.phoneNumber : user.email : <></>} */}
              Learner
            </span>
          </label>
          <p className="mt-4">Enter your details</p>
          <div className="form-row">
            {user.name ? ""
              :
              <div className="col">
                <input
                  id="fname"
                  type="text"
                  className="form-control RegInput "
                  placeholder="Full name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            }

            { user.email  ? "" :
              <div className="col">

                <input
                  id="emailfield"
                  type="email"
                  className="form-control RegInput"
                  placeholder="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            }



          </div>
          <div className="form-row mt-3">
            {user.phoneNumber ? "" :
              <div className="col-md-6">

                <input
                  id="numberfield"
                  type="number"
                  className="form-control RegInput"
                  placeholder="Phone Number"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  required
                />
              </div>
            }


            {user.city ? "" :
              <div className="col-md-6">
                <input
                  id="cityfield"
                  type="text"
                  className="form-control RegInput"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  required
                />
              </div>
            }
          </div>
          {/* <div className="form-row mt-4">
            <div className="col">
              <input
                id="prof"
                type="text"
                className="form-control RegInput"
                placeholder="Profession"
                value={profession}
                onChange={(e) => setProfession(e.target.value)}
                required
              />
            </div>

            <div className="col">
              {user.phoneNumber ? (
                <input
                  id="emailfield"
                  type="email"
                  className="form-control RegInput "
                  placeholder="E-mail"
                  value={emailOrPhonenumber}
                  onChange={(e) => setEmailOrPhonenumber(e.target.value)}
                  required
                />
              ) : (
                // ""
                <input
                  type="number"
                  className="form-control RegInput "
                  placeholder="Phone Number"
                  value={emailOrPhonenumber}
                  onChange={(e) => setEmailOrPhonenumber(e.target.value)}
                  required
                />
              )}


            </div>
          </div> */}


          {/* <div className="form-row mt-5">
            <div className="col-6">
              <label>Referral code(Optional)</label>
              <input
                id="reffcode"
                type="text"
                className="form-control no-border"
                placeholder="Referral code"
                value={referal}
                onChange={(e) => setReferal(e.target.value)}
              ></input>
            </div>
          </div> */}

          {/* <div className="mt-5">
            <p>Your level:</p>
            <div class="form-check form-check-inline ">
              <input
                id="begfield"
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio1"
                value="Beginner"
                onChange={(e) => setLevel(e.target.value)}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                Beginner
              </label>
            </div>
            <div class="form-check form-check-inline pl-1 pr-1">
              <input
                id="intfield"
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio2"
                value="Intermediate"
                onChange={(e) => setLevel(e.target.value)}
              />
              <label class="form-check-label" htmlFor="inlineRadio2">
                Intermediate
              </label>
            </div>
            <div class="form-check form-check-inline ">
              <input
                id="advfield"
                className="form-check-input "
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio3"
                value="Advanced"
                onChange={(e) => setLevel(e.target.value)}
              />

              <label className="form-check-label" htmlFor="inlineRadio3">
                Advanced
              </label>
            </div>
          </div> */}
          <button
            type="submit"
            disabled={loder ? true : false}
            className={loder ? "continueBTNdisabled btn-block mx-auto" : "continueBTN  btn-block mx-auto"}
          >
            {loder ? (
              "Loading ..."
            ) : (
              "Continue"
            )}
          </button>
          <p className="text-center mt-1 text-danger">{errormsg}</p>


        </div>
      </div>
    </form>
  );
};

export default InfoForm;
